import { css } from 'aphrodite';
import { IMeetingConfigInfo } from '../../../extViewmodels';
import { ScheduleMeetingHeaderHost } from '../../ScheduleMeetingHeaderHost';
import { styleSheet as pageStyles } from '../../styles/styles';
import { getDurationText } from '../../UiUtils';
import { styleSheet } from './styles';
import { Button } from '../../../web/components-v2/Button';
import { AlarmClockIcon } from '../../../web/components/svgs/icons/AlarmClockIcon';

export type IMeetingLandingCard = Pick<IMeetingConfigInfo, 'name' | 'duration' | 'shortCode' | 'vanityPath'>;

interface IProps {
	companyName: string;
	creatorName: string;
	hasCustomHeaderOrFooter?: boolean;
	meetingConfigs: IMeetingLandingCard[];
	onBookMeeting?: (meeting: IMeetingLandingCard) => void;
}

export const MeetingLandingBody = ({
	companyName,
	creatorName,
	hasCustomHeaderOrFooter,
	meetingConfigs,
	onBookMeeting,
}: IProps) => {
	return (
		<div
			className={css(
				styleSheet.mainContainer,
				pageStyles.sharedBackgroundWrapper,
				hasCustomHeaderOrFooter && pageStyles.sharedBackgroundWrapperMobileNoCustom
			)}
		>
			<div className={css(styleSheet.contentContainer)}>
				<div className={css(pageStyles.container, styleSheet.container)}>
					<div className={css(pageStyles.header, styleSheet.header)}>
						<ScheduleMeetingHeaderHost host={creatorName} company={companyName} isReschedule={false} />
					</div>
					<div>
						<div className={css(styleSheet.meetings)}>
							{meetingConfigs.map(meeting => {
								return (
									<div className={css(styleSheet.card)} key={`/${meeting.shortCode}/${meeting.vanityPath}`}>
										<div className={css(styleSheet.cardHeader)}>
											<div className={css(styleSheet.meetingName)}>{meeting.name}</div>
											<span className={css(pageStyles.label, styleSheet.label)}>
												<AlarmClockIcon />
												<span>{getDurationText(meeting.duration)}</span>
											</span>
										</div>
										<Button onClick={onBookMeeting ? () => onBookMeeting(meeting) : undefined} size='sm'>
											Book Meeting
										</Button>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
